// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federwindeautomaten/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federwindeautomatenDE: PageEntry = {
  id: "post.federwindeautomaten",
  locale: "de",
  slug: "federwindeautomaten",
  seo: {
    title: "Glossar: Federwindeautomaten einfach erklärt | Dietz GmbH",
    description: "Federwindeautomaten sind spezialisierte Maschinen, die für die automatische Herstellung von Federn verwendet werden. Diese Maschinen ermöglichen einen präzisen und effizienten Fert",
  },
  type: "post",
  h1: "Glossar: Federwindeautomaten einfach erklärt",
  intro: "Federwindeautomaten sind spezialisierte Maschinen, die für die automatische Herstellung von Federn verwendet werden. Diese Maschinen ermöglichen einen präzisen und effizienten Fertigungsprozess, bei dem Draht automatisch gewickelt, gebogen und geschnitten wird, um die gewünschte Federform zu erreichen. Federwindeautomaten spielen eine entscheidende Rolle in der Massenproduktion von Federn für verschiedene Anwendungen, von industriellen Maschinen bis zu elektronischen Geräten. Die Automatisierung dieses Prozesses trägt zur Kosteneffizienz und Konsistenz in der Federherstellung bei.",
  blocks: [

  ],
};
